module.exports = __webpack_public_path__ + "media/images/game_icon/zh-tw/AB1003-bc371bd7d3e55d2c72000cffe02a9848.png";